import { api } from "@/api/client";

export interface Plan {
  key: "free" | "pro" | "enterprise";
  name: string;
  monthly_price_usd: number;
  blurb: string;
  quotas: {
    render_seconds_per_month: number;
    transcribe_seconds_per_month: number;
    storage_bytes: number;
    max_projects: number;
    allow_premium_ai_tier: boolean;
  };
}

export interface Usage {
  plan_key: string;
  plan_name: string;
  period_key: string;
  counters: Record<string, number>;
  limits: Record<string, number>;
}

export const billingApi = {
  listPlans() {
    return api<Plan[]>("/billing/plans");
  },
  usage() {
    return api<Usage>("/billing/usage");
  },
  startCheckout(plan_key: Plan["key"]) {
    return api<{ checkout_url: string }>("/billing/checkout", {
      method: "POST",
      body: { plan_key },
    });
  },
  openPortal() {
    return api<{ portal_url: string }>("/billing/portal", { method: "POST" });
  },
};

export const oauthApi = {
  listProviders() {
    return api<{ enabled: string[] }>("/auth/oauth/providers");
  },
};
